import type { QueryFilter, MapPinsResult } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getMapPins } from "@/graphql/queries";

const client = generateClient();

export const restaurantsPinsState = create<State<MapPinsResult>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getRestaurantsPinsIsloading = () =>
  restaurantsPinsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getRestaurantsPinsIsError = (error: Error) =>
  restaurantsPinsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getRestaurantsPinsIsSuccess = (queryResult: MapPinsResult) =>
  restaurantsPinsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
  }));

export const getRestaurantsPins = async (
  queryFilters: QueryFilter[],
  append = false,
) => {
  if (!append) getRestaurantsPinsIsloading();

  try {
    const { data } = await client.graphql({
      query: getMapPins,
      variables: {
        filters: queryFilters,
        offset: append
          ? (restaurantsPinsState.getState().data?.data.length ?? 0)
          : 0,
      },
    });

    if (!append) getRestaurantsPinsIsSuccess(data.getMapPins as MapPinsResult);

    if (append)
      getRestaurantsPinsIsSuccess({
        total: data.getMapPins.total,
        data: [
          ...(restaurantsPinsState.getState().data?.data ?? []),
          ...data.getMapPins.data,
        ],
      } as MapPinsResult);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query restauants pins";
    getRestaurantsPinsIsError(Error(errorMessage));
  }
};
